// extracted by mini-css-extract-plugin
module.exports = {"offer__bg":"MainPage_offer__bg__2VDpc","blue__bg":"MainPage_blue__bg__1EAff"};